export enum TooltipInfoCopy {
  Spacing = 'Distance between consecutive drill holes in a row.',
  Burden = 'Distance from each drill hole to the nearest free face.',
  BaseElevation = 'Elevation at the bottom of the blast area, used to calculate drill hole depths.',
  ExtentTooltip = 'Marks the maximum allowed boundary for drilling operations, ensuring blast safety and compliance.',
  ExpectedNumberOfHoles = 'Approximate total number of drill holes planned for the blast.',
  AoiDisabledByExtent = "Please exit 'Extent for the Blast' drawing mode to proceed.",
  ExtentDisabledByAoi = "Please exit 'Mark Area of Interest' drawing mode to proceed.",
}
